export const logout = () => {
  window.parent.primingcloud.navigation.logout()
}
export const showMainNavigation = () => {
  window.parent.primingcloud.navigation.showMainNavigation()
}
export const openMainNavigation = () => {
  window.parent.primingcloud.navigation.openMainNavigation()
}
export const startCustomUI = (customUiName: string, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.navigation.startCustomUI(
      customUiName,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}
export const hideMainNavigation = () => {
  window.parent.primingcloud.navigation.hideMainNavigation()
}

export const loadContent = (key: string) => {
  window.parent.primingcloud.navigation.loadContent(key)
}

export const startWebbundleGeneric = (
  customerName: string,
  appName: string,
  customUiName: string,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.navigation.startWebbundleGeneric(
      customerName,
      appName,
      customUiName,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const startCustomUIWithoutMenu = (customUiName: string) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.navigation.startCustomUIWithoutMenu(
      customUiName,
      (data: unknown) => resolve(data)
    )
  })
}

export const getApplicationPath = () => {
  window.parent.primingcloud.navigation.getApplicationPath()
}

export const getHostPageBaseURL = () => {
  window.parent.primingcloud.navigation.getHostPageBaseURL()
}

export const getAllExecutableWebBundles = (
  param?: boolean /* TODO: Change the name of param here to something meaningful */,
  context?: unknown
) => {
  return new Promise((resolve) => {
    window.parent?.primingcloud?.navigation?.getAllExecutableWebBundles(
      param ?? false,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const jumpToWebBundle = (
  customer: string,
  application: string,
  bundle: string,
  param?: boolean /* TODO: Change the name of param here to something meaningful */
) => {
  window.parent?.primingcloud?.navigation?.jumpToWebBundle(
    customer,
    application,
    bundle,
    param ?? false
  )
}
